const SET_TICKETS_LIST: string = 'SET_TICKETS_LIST';
const UPDATE_TICKETS: string = 'UPDATE_TICKETS';
const SET_DEFAULT_CONTROLLER: string = 'SET_DEFAULT_CONTROLLER';
const SET_TICKET_ATTACHMENTS: string = 'SET_TICKET_ATTACHMENTS';
const SET_TICKET_ACTIVE_TASK_DATA: string = 'SET_TICKET_ACTIVE_TASK_DATA';
const SET_TICKET_ACTIVE_TASK_FROM_PROPERTIES_LIST: string = 'SET_TICKET_ACTIVE_TASK_FROM_PROPERTIES_LIST';
const SET_TICKET_DOCUMENTS: string = 'SET_TICKET_DOCUMENTS';
const SET_MODAL_FLAGS: string = 'SET_MODAL_FLAGS';
const SET_MODALS_DATA: string = 'SET_MODALS_DATA';
const SET_TICKET_DETAILS: string = 'SET_TICKET_DETAILS';
const SET_ALL_USERS_FOR_QUEUE: string = 'SET_ALL_USERS_FOR_QUEUE';
const SET_BULK_ASSIGNMENT_USERS: string = 'SET_BULK_ASSIGNMENT_USERS';
const SET_TICKET_CATEGORY: string = 'SET_TICKET_CATEGORY';
const SET_CUSTOM_FIELD_OPTIONS: string = 'SET_CUSTOM_FIELD_OPTIONS';
const SET_TICKET_ASSIGNEE: string = 'SET_TICKET_ASSIGNEE';
const SET_TICKET_REQUESTERS: string = 'SET_TICKET_REQUESTERS';
const SET_TICKET_FORM_DATA: string = 'SET_TICKET_FORM_DATA';
const SET_DATA_ERROR: string = 'SET_DATA_ERROR';
const SET_TICKET_LIST_API_TYPE: string = 'SET_TICKET_LIST_API_TYPE';
const SET_TAGS_LIST: string = 'SET_TAGS_LIST';
const SET_AUTO_VERIFICATION: string = 'SET_AUTO_VERIFICATION';

export const TICKET_LIST_ACTION_TYPES = {
    SET_TICKETS_LIST,
    UPDATE_TICKETS,
    SET_DEFAULT_CONTROLLER,
    SET_MODAL_FLAGS,
    SET_MODALS_DATA,
    SET_TICKET_ATTACHMENTS,
    SET_TICKET_ACTIVE_TASK_DATA,
    SET_TICKET_ACTIVE_TASK_FROM_PROPERTIES_LIST,
    SET_TICKET_DOCUMENTS,
    SET_TICKET_DETAILS,
    SET_ALL_USERS_FOR_QUEUE,
    SET_BULK_ASSIGNMENT_USERS,
    SET_TICKET_CATEGORY,
    SET_CUSTOM_FIELD_OPTIONS,
    SET_TICKET_ASSIGNEE,
    SET_TICKET_REQUESTERS,
    SET_TICKET_FORM_DATA,
    SET_DATA_ERROR,
    SET_TICKET_LIST_API_TYPE,
    SET_TAGS_LIST,
    SET_AUTO_VERIFICATION,
};
